import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";

const Container = tw.section`relative max-w-screen-xl mx-auto py-20 md:py-24`;
const Header = tw.div`max-w-3xl mx-auto text-center`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)``;
const Introduction = tw.p`mt-6 text-base md:text-lg font-medium leading-relaxed text-secondary-100`;
const Grid = tw.div`mt-12 grid gap-6 md:grid-cols-2`;
const Role = styled.article`
  ${tw`p-6 md:p-8 rounded-lg border border-gray-200 bg-white shadow-sm`}
`;
const RoleHeader = tw.div`flex flex-col sm:flex-row sm:items-start sm:justify-between`;
const Company = tw.h3`text-xl font-bold text-gray-900`;
const Dates = tw.span`mt-1 sm:mt-0 text-sm font-semibold text-primary-500`;
const Title = tw.p`mt-2 font-bold text-gray-700`;
const Description = tw.p`mt-4 text-sm md:text-base leading-relaxed text-secondary-100`;
const Technologies = tw.p`mt-4 text-sm font-semibold text-gray-600`;

const roles = [
  {
    company: "BRAHMA AI",
    dates: "2023 — Present",
    title: "Senior Pipeline Engineer",
    description: "Developing Python and Flask tools and services for AI-enabled content production, technical operations and dependable workflow automation.",
    technologies: "Python · Flask · GitHub Actions · Nuke · RV · Rez · ShotGrid"
  },
  {
    company: "Qstream",
    dates: "2022 — 2023",
    title: "Software Engineer",
    description: "Designed scalable backend services and REST APIs, maintained OpenAPI specifications, applied test-driven development and supported event-driven AWS workflows.",
    technologies: "Python · Django REST Framework · OpenAPI · PostgreSQL · AWS"
  },
  {
    company: "SSVFX",
    dates: "2017 — 2021",
    title: "Head of Pipeline · Pipeline TD",
    description: "Led pipeline development for a 50–100 person VFX studio and built production systems for ShotGrid integration, media processing, delivery automation and DCC workflows.",
    technologies: "Python · Django · ShotGrid · Nuke · Maya · 3ds Max · Deadline"
  },
  {
    company: "Animation & VFX Production",
    dates: "2009 — 2016",
    title: "Technical Director · Lead Character Rigger",
    description: "Built studio tools, pipeline processes and technical production systems across Giant Animation, Brown Bag Films, independent projects and feature-film previs.",
    technologies: "Python · MaxScript · Maya · 3ds Max · Production Tooling"
  }
];

export default () => (
  <Container id="experience">
    <Header>
      <Subheading>Experience</Subheading>
      <Heading>From production pipelines to <span tw="text-primary-500">backend platforms.</span></Heading>
      <Introduction>
        More than 15 years across software engineering, VFX, animation and production technology,
        with a focus on practical systems that improve reliability, scale and delivery.
      </Introduction>
    </Header>
    <Grid>
      {roles.map(role => (
        <Role key={`${role.company}-${role.dates}`}>
          <RoleHeader>
            <Company>{role.company}</Company>
            <Dates>{role.dates}</Dates>
          </RoleHeader>
          <Title>{role.title}</Title>
          <Description>{role.description}</Description>
          <Technologies>{role.technologies}</Technologies>
        </Role>
      ))}
    </Grid>
  </Container>
);
